module.exports = __webpack_public_path__ + "static/hexblade-mtg_afr-fb647e120594da1a5e708accd766ded7.jpg";